module.exports = __webpack_public_path__ + "assets/img/19@3x.79d3c71d.png";